import { ProgramDay } from '../enums';
import { z } from 'zod';

import { CoverSourceName } from './asset-source';
import { Translation } from './translation';
import { MealTypeEnum } from './meal';

export const MealDayDto = z.object({
  mealId: z.string().uuid(),
  day: z.enum([
    ProgramDay.MONDAY,
    ProgramDay.TUESDAY,
    ProgramDay.WEDNESDAY,
    ProgramDay.THURSDAY,
    ProgramDay.FRIDAY,
    ProgramDay.SATURDAY,
    ProgramDay.SUNDAY,
  ]),
  mealType: MealTypeEnum,
  mealTime: z.string(),
});

export const MealWeekDto = z.object({
  weekIndex: z.number().nonnegative(),
  weekName: z.string().optional(),
  mealDays: z.array(MealDayDto).optional(),
});

export const CreateNutritionPlanDto = z.object({
  coverSource: CoverSourceName.optional(),
  coverType: z.string().optional(),
  // Accepted and IGNORED (here and on update): the server derives a plan's
  // kcal totals from its meals on every read. Kept so a browser still running
  // an older bundle is not refused with a 422 for sending them.
  totalKcal: z.number().nonnegative().optional(),
  totalDays: z.number().int().nonnegative().optional(),
  averageKcalPerDay: z.number().nonnegative().optional(),
  tags: z.array(z.string()).optional(),
  translations: z.array(Translation),
  weeks: z.array(MealWeekDto).optional(),
  configuration: z
    .object({
      isOrg: z.boolean().optional(),
      marketplace: z
        .object({
          enabled: z.boolean(),
          price: z.number().nonnegative().optional(),
          currency: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
});

export type ApiCreateNutritionPlanDto = z.infer<typeof CreateNutritionPlanDto>;

export const UpdateNutritionPlanDto = z
  .object({
    coverSource: CoverSourceName.optional().nullable(),
    coverType: z.string().optional(),
    totalKcal: z.number().nonnegative().optional(),
    totalDays: z.number().int().nonnegative().optional(),
    averageKcalPerDay: z.number().nonnegative().optional(),
    tags: z.array(z.string()).optional(),
    translations: z.array(Translation).optional(),
    weeks: z.array(MealWeekDto).optional(),
    configuration: z
      .object({
        isOrg: z.boolean().optional(),
        marketplace: z
          .object({
            enabled: z.boolean(),
            price: z.number().nonnegative().optional(),
            currency: z.string().optional(),
          })
          .optional(),
      })
      .optional(),
  })
  .strict();

export type ApiUpdateNutritionPlanDto = z.infer<typeof UpdateNutritionPlanDto>;
